import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from '../posthog';

export default function PostHogPageView() {
  const location = useLocation();
  const lastPathRef = useRef(null);
  const isDevelopment = process.env.NODE_ENV === 'development';

  useEffect(() => {
    if (isDevelopment) return;

    const path = `${location.pathname}${location.search}${location.hash}`;

    // React 18 StrictMode runs effects twice in dev; also avoid duplicates on same route.
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;

    posthog.capture('$pageview', {
      $current_url: window.location.href,
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    });
  }, [location]);

  return null;
}

